import React from 'react'

const Footer = () => {
  return (
    <div className='bg-black text-center p-6 text-white ' >
Copyright © ${new Date().getFullYear()} All Rights Reserved 
   </div>
  )
}

export default Footer
